import { JetView } from 'webix-jet';
import { devConfig, countries, profile } from 'config/config';

/**
 * Class representing the FilterTransfersView.
 * @extends JetView
 */
export default class FilterTransfersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing input fields for filtering
        const left = {
            margin: 5,
            id: 'a1',
            autoheight: true,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Id',
                            type: 'number',
                            label: "<span class='icon-id'></span>" + _('ID'), // ID label
                            labelPosition: 'top',
                            placeholder: _('ID'), // Placeholder for ID input
                        },
                        {
                            view: 'combo',
                            name: 'UserCreate',
                            label: "<span class='icon-user'></span>" + _('Usuario Creó'), // User created label
                            labelPosition: 'top',
                            container: 'cmb',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed for UserCreate combo
                                        this.parse(
                                            webix.ajax(devConfig.geturlApi() + 'Agent/SearchAgent?filter=' + text),
                                        );
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'UserReceive',
                            label: "<span class='icon-user'></span>" + _('Usuario Recibió'), // User received label
                            labelPosition: 'top',
                            container: 'cmb',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed for UserReceive combo
                                        this.parse(
                                            webix.ajax(devConfig.geturlApi() + 'Agent/SearchAgent?filter=' + text),
                                        );
                                    },
                                },
                            },
                        },
                        {
                            view: 'text',
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Date range value
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for datepicker
                        },
                        {
                            view: 'datepicker',
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for datepicker
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum date for the datepicker
                                },
                            },
                        },
                    ],
                },
            ],
        };

        // Second left section (currently empty)
        const left2 = {
            margin: 5,
            id: 'a1',
            autoheight: true,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [{ id: 'grav2', gravity: 1 }],
                },
            ],
        };

        // Upper section containing the first left section
        const upper_section = {
            height: document.body.offsetWidth < 500 ? 250 : 0, // Conditional height based on screen width
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Upper section 2 containing the second left section
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 300 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };

        // Accordion section containing advanced filters
        const accordion_section2 = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Advanced filters header
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for clearing and consulting
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country selection
                        $$('Datepicker').setValue(''); // Clear datepicker
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter',
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter data from form
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('transfers:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Main accordion section containing filters and buttons
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Filters header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'myForm', // Form ID
            type: 'clean',
            rows: [accordion_section],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for fname
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if condition is true
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
